import toastMessage from "../../utils/toastMessage";
import language from "../../language";
import formatDropdownData from "../../utils/formatDropdownData";
import axios from "axios";
import api from "../../utils/api";

export default async (lng = "english", { listType }) => {
  try {
    const options = {
      method: "GET",
      url: `${api("location")}/public/countries/active`,
      data: null, //force axios send headers content type
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "name", "id");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_all_counties);
  }
};
